import { Component, OnDestroy, OnInit } from '@angular/core';
import { AlertController, ToastController } from '@ionic/angular';
import { Subscription } from 'rxjs';
import { GepjarmuService } from '../gepjarmu.service';
import { SzerkZar, SzerkZarService } from '../../components/szerk-zar/szerk-zar.service';

/*  GÉPJÁRMŰ – Címtár: telephelyek (a cég saját helyei, innen indulnak az utak), partnerek (a Könyvelés
 *  partnertörzséből is átvehetők) és magáncímek; a Távolságok fülön két cím közti km (az útrögzítő ebből
 *  javasol). Szerkesztési zár: gepjarmu_cim. */
@Component({
  selector: 'app-gj-cimtar',
  templateUrl: './cimtar.component.html',
  styleUrls: ['../../naplo/naplo-shared.scss', '../gepjarmu-shared.scss'],
})
export class GjCimtarComponent implements OnInit, OnDestroy {
  nezet: 'cimek' | 'tavolsagok' = 'cimek';
  cimek: any[] = [];
  tavolsagok: any[] = [];
  fajtak: Record<string, string> = { telephely: 'Telephely (saját)', partner: 'Partner', magan: 'Magáncím (pl. lakcím)' };
  fajtaSzuro = '';
  kereso = '';
  inaktiv = false;
  betolt = false;
  szerk: any = null;
  zar: SzerkZar | null = null;
  ment = false;
  // Könyvelés-partner átvétel
  atvetel: { lista: any[]; kereso: string; kijelolt: Set<string>; betolt: boolean } | null = null;
  // távolság-űrlap
  tav = { cim_a: null as string | null, cim_b: null as string | null, km: null as number | null };
  tavKereso = '';
  private zarKor = 0;
  private sub?: Subscription;

  constructor(public gj: GepjarmuService, private toast: ToastController, private alert: AlertController, private szerkZar: SzerkZarService) {}
  get u() { return this.gj.aktiv.ugyfelId; }
  get ir() { return this.gj.ir; }
  get zarolt() { return !!this.zar && !this.zar.irhato; }

  async ngOnInit() {
    await this.gj.init();
    try { const sz: any = await this.gj.get('/szotarak'); if (sz?.cim_fajta) this.fajtak = sz.cim_fajta; } catch { /* a beépített nevek maradnak */ }
    this.sub = this.gj.aktiv$.subscribe(() => this.frissit());
  }
  ngOnDestroy() { this.sub?.unsubscribe(); this.zarElenged(); }
  get fajtaLista() { return Object.entries(this.fajtak).map(([k, v]) => ({ k, v })); }

  async frissit() {
    if (!this.u) { this.cimek = []; this.tavolsagok = []; return; }
    this.betolt = true;
    try {
      const [c, t] = await Promise.all([this.gj.get(`/cimek/${this.u}`), this.gj.get(`/tavolsagok/${this.u}`)]);
      this.cimek = c; this.tavolsagok = t;
    } catch (e: any) { this.hiba(e?.error?.error || 'Nem sikerült betölteni a címtárat.'); }
    finally { this.betolt = false; }
  }
  get lathato(): any[] {
    const k = this.kereso.trim().toLowerCase();
    return this.cimek.filter((c) => (this.inaktiv || c.aktiv) && (!this.fajtaSzuro || c.fajta === this.fajtaSzuro)
      && (!k || [c.nev, c.teljes, c.adoszam, c.csoport].some((x) => String(x || '').toLowerCase().includes(k))));
  }
  db(fajta: string) { return this.cimek.filter((c) => c.aktiv && c.fajta === fajta).length; }
  get vanTelephely() { return this.cimek.some((c) => c.fajta === 'telephely'); }
  get csoportok(): string[] { return [...new Set(this.cimek.map((c) => c.csoport).filter(Boolean))].sort(); }

  /* ── cím szerkesztő ── */
  uj(fajta = this.fajtaSzuro || 'partner') {
    this.zarElenged();
    this.szerk = { id: null, fajta, nev: '', irsz: '', telepules: '', cim: '', adoszam: '', csoport: '', aktiv: true, megjegyzes: '' };
  }
  nyit(c: any) { this.szerk = this.szerkAdat(c); this.zarFoglal(String(c.id)); }
  private szerkAdat(c: any) { return { ...c, aktiv: !!Number(c.aktiv), csoport: c.csoport || '', megjegyzes: c.megjegyzes || '' }; }
  private async zarFoglal(id: string) {
    this.zarElenged();
    if (!this.ir) return;
    const kor = this.zarKor;
    const z = await this.szerkZar.foglal('gepjarmu', 'gepjarmu_cim', id, { ujratolt: () => this.ujratolt(id) });
    if (kor !== this.zarKor || String(this.szerk?.id) !== id) { z?.felenged(); return; }
    this.zar = z;
  }
  private zarElenged() { this.zarKor++; this.zar?.felenged(); this.zar = null; }
  bezar() { this.szerk = null; this.zarElenged(); }
  private async ujratolt(id: string) {
    this.cimek = await this.gj.get(`/cimek/${this.u}`);
    const c = this.cimek.find((x) => String(x.id) === id);
    if (c && String(this.szerk?.id) === id) this.szerk = this.szerkAdat(c);
  }
  async mentes() {
    if (this.zarolt || this.ment) return;
    const s = this.szerk;
    this.ment = true;
    try {
      if (s.id) await this.gj.put(`/cim/${s.id}`, s); else await this.gj.post(`/cim/${this.u}`, s);
      this.bezar(); this.ok('Cím mentve.'); await this.frissit();
    } catch (e: any) { this.hiba(e?.error?.error || 'Nem sikerült menteni.'); }
    finally { this.ment = false; }
  }
  async torol() {
    if (this.zarolt || !this.szerk?.id) return;
    const s = this.szerk;
    const a = await this.alert.create({
      header: 'Cím törlése', message: `Biztosan törlöd: ${s.nev}? A hozzá rögzített távolságok is törlődnek.`,
      buttons: [{ text: 'Mégse', role: 'cancel' }, { text: 'Törlés', role: 'destructive', handler: () => { this.torolVeg(s.id); } }],
    });
    await a.present();
  }
  private async torolVeg(id: string) {
    try { await this.gj.del(`/cim/${id}`); this.bezar(); this.ok('Cím törölve.'); await this.frissit(); }
    catch (e: any) { this.hiba(e?.error?.error || 'Nem sikerült törölni.'); }
  }
  async telephelyCegbol() {
    try {
      const r: any = await this.gj.post(`/cimek/${this.u}/telephely-cegbol`);
      this.ok(r.uj ? `Telephely felvéve a cég címéből${r.alap ? ', és ez lett az alapértelmezett' : ''}.` : 'A cég címe már szerepel telephelyként.');
      await this.frissit();
    } catch (e: any) { this.hiba(e?.error?.error || 'Nem sikerült.'); }
  }

  /* ── átvétel a Könyvelés partnertörzséből ── */
  async atvetelNyit() {
    this.atvetel = { lista: [], kereso: '', kijelolt: new Set(), betolt: true };
    try { this.atvetel.lista = await this.gj.get(`/naplo-partnerek/${this.u}`); }
    catch (e: any) { this.hiba(e?.error?.error || 'Nem sikerült betölteni a partnereket.'); }
    finally { if (this.atvetel) this.atvetel.betolt = false; }
  }
  get atvetelLathato(): any[] {
    const a = this.atvetel; if (!a) return [];
    const k = a.kereso.trim().toLowerCase();
    return a.lista.filter((p) => !k || [p.nev, p.rovid_nev, p.adoszam, p.teljes].some((x) => String(x || '').toLowerCase().includes(k)));
  }
  get atvehetoLathato(): any[] { return this.atvetelLathato.filter((p) => !p.atveve); }
  get mindKijelolve(): boolean { const l = this.atvehetoLathato; return l.length > 0 && l.every((p) => this.atvetel!.kijelolt.has(p.id)); }
  mindValt(v: boolean) { for (const p of this.atvehetoLathato) { if (v) this.atvetel!.kijelolt.add(p.id); else this.atvetel!.kijelolt.delete(p.id); } }
  valt(p: any, v: boolean) { if (v) this.atvetel!.kijelolt.add(p.id); else this.atvetel!.kijelolt.delete(p.id); }
  async atvetelMent() {
    if (!this.atvetel?.kijelolt.size) return;
    try {
      const r: any = await this.gj.post(`/cimek/${this.u}/naplobol`, { idk: [...this.atvetel.kijelolt] });
      this.atvetel = null;
      this.ok(`${r.db} partner átvéve${r.kihagyva ? `, ${r.kihagyva} már szerepelt` : ''}.`);
      await this.frissit();
    } catch (e: any) { this.hiba(e?.error?.error || 'Nem sikerült az átvétel.'); }
  }

  /* ── távolságok ── */
  get aktivCimek() { return this.cimek.filter((c) => c.aktiv); }
  get tavLathato(): any[] {
    const k = this.tavKereso.trim().toLowerCase();
    return this.tavolsagok.filter((t) => !k || [t.a_nev, t.b_nev, t.a_cim, t.b_cim].some((x) => String(x || '').toLowerCase().includes(k)));
  }
  tavNyit(t: any) { this.tav = { cim_a: t.cim_a, cim_b: t.cim_b, km: t.km }; }
  /*  Ha a két cím között már van rögzített távolság, az űrlap mutatja. */
  tavValt() {
    const { cim_a, cim_b } = this.tav;
    const t = this.tavolsagok.find((x) => (x.cim_a === cim_a && x.cim_b === cim_b) || (x.cim_a === cim_b && x.cim_b === cim_a));
    if (t) this.tav.km = t.km;
  }
  get tavMeglevo(): boolean {
    const { cim_a, cim_b } = this.tav;
    return this.tavolsagok.some((x) => (x.cim_a === cim_a && x.cim_b === cim_b) || (x.cim_a === cim_b && x.cim_b === cim_a));
  }
  async tavMent() {
    try {
      await this.gj.put(`/tavolsag/${this.u}`, this.tav);
      this.ok('Távolság mentve.');
      this.tav = { cim_a: this.tav.cim_a, cim_b: null, km: null };
      this.tavolsagok = await this.gj.get(`/tavolsagok/${this.u}`);
    } catch (e: any) { this.hiba(e?.error?.error || 'Nem sikerült menteni a távolságot.'); }
  }
  async tavTorol(t: any) {
    try { await this.gj.del(`/tavolsag/${this.u}/${t.cim_a}/${t.cim_b}`); this.tavolsagok = await this.gj.get(`/tavolsagok/${this.u}`); }
    catch (e: any) { this.hiba(e?.error?.error || 'Nem sikerült törölni.'); }
  }
  km(v: any) { return v == null ? '' : Number(v).toLocaleString('hu-HU', { maximumFractionDigits: 1 }); }

  private async ok(m: string) { (await this.toast.create({ message: m, duration: 2600, color: 'success' })).present(); }
  private async hiba(m: string) { (await this.toast.create({ message: m, duration: 5200, color: 'danger' })).present(); }
}
